import React from "react";
import { useAppDispatch } from "../../hook/redux";
import { handleDisplayToolbar } from "../utils";

const ClosingToolBarButton = ({canvas}) => {

  const dispatch = useAppDispatch();


  /**
   * Handles the click event for the close button.
   *
   * This function is typically used to dismiss or reset the currently active object
   * on a canvas when the close button is clicked. If a canvas element is referenced,
   * it discards the active object and triggers a re-render of the canvas to reflect the changes.
   *
   * @function
   */
  const handleCloseButtonClick = () => {
    if (canvas.current) {
      canvas.current.discardActiveObject();
      canvas.current.renderAll();
    }
  };

  return (
    <div
      className="p-1 d-flex justify-content-end"
      onClick={ () => {
        handleCloseButtonClick();
        handleDisplayToolbar( dispatch, "layout" );
      } }
      style={{ display: 'flex', alignItems: 'center', gap: '8px', cursor: "pointer" }}
    >
     <i
      className="fas fa-times"
      style={{
      color: 'red',
      fontSize: '2rem',
    }}
      ></i>
  <span style={{ fontSize: '1.5rem' }}>Retour</span>
    </div>
  );
};

export default ClosingToolBarButton;
